/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */


/*
*Takes an array of a list of numbers as input and returns an array containing a list of numbers
*that is analogous to the input in the order of its elements relative to their order if they were 
*sorted in ascending order. Thus the structure of the list is reproduced with different values.
*/
function createAnalogousList (sortlist){
    let sortedlist = JSON.parse(JSON.stringify(sortlist)).sort((a, b) => a-b); 
    let positions = sortlist.map((value) => sortedlist.indexOf(value)); //positions contains the positions of the elements in the sorted list in the order of the non-sorted list
    var analogous = [];
    //input-lists contain either elements between 0-20 or 0-50
    if(sortedlist[sortedlist.length-1] <= 20){
        analogous = createRandomList(20, sortlist); 
    } else{
        analogous = createRandomList(50, sortlist);
    }
    let sortedAnalogous = analogous.sort((a,b) => a-b);  
    let trueAnalogous = positions.map((index) => sortedAnalogous[index]); //bring the analogous list into the same relative order as the input list to make it truly analogous
    
    return trueAnalogous;
}


/*
* Creates a random list of numbers ot he same length as the inputlist within a specified range 
* that does not contain duplicates within itself or with the input.
*/
function createRandomList(rangelimit, inputlist) { 
    let analogous = [];
    for(let i = 0; i< inputlist.length; i++){
        let newNumber = Math.floor(Math.random() * rangelimit) + 1; 
        console.log(newNumber);
        //if the number is already contained in the analogous list or in the original sortlist create a new one
        if(analogous.indexOf(newNumber) !== -1 || inputlist.indexOf(newNumber) !== -1){
            i--;
        } else{
            analogous[i] = newNumber;
        }
    }
   return analogous;
}

module.exports = {createAnalogousList};